import { datadogLogs } from '@datadog/browser-logs';

export type DatadogLogsConfig = {
  enabled?: string;
  clientToken?: string;
  service?: string;
  env?: string;
};

let initialized = false;

// Paths and query strings carry referral ids and registration tokens, so only
// the origin may leave the browser.
function toOrigin(value: string): string {
  try {
    return new URL(value).origin;
  } catch {
    return value;
  }
}

export function initDatadogLogs({
  enabled,
  clientToken,
  service,
  env,
}: DatadogLogsConfig): void {
  if (initialized || typeof document === 'undefined') {
    return;
  }

  if (enabled !== 'true') {
    console.warn(
      '[Datadog] Log collection is disabled; CSP violations will not be reported.'
    );
    return;
  }

  if (!clientToken || !service) {
    console.warn(
      '[Datadog] Log collection is not configured; CSP violations will not be reported.'
    );
    return;
  }

  datadogLogs.init({
    clientToken,
    site: 'datadoghq.eu',
    service,
    env,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
    beforeSend: (log) => {
      log.view.url = toOrigin(log.view.url);
      if (log.view.referrer) {
        log.view.referrer = toOrigin(log.view.referrer);
      }
      return true;
    },
  });

  document.addEventListener('securitypolicyviolation', (event) => {
    datadogLogs.logger.warn('csp.violation', {
      blockedURI: toOrigin(event.blockedURI),
      violatedDirective: event.violatedDirective,
      effectiveDirective: event.effectiveDirective,
      originalPolicy: event.originalPolicy,
      disposition: event.disposition,
      sourceFile: toOrigin(event.sourceFile),
      lineNumber: event.lineNumber,
      columnNumber: event.columnNumber,
      statusCode: event.statusCode,
    });
  });

  initialized = true;
}
